import React from "react"

import ConfirmSessionButton from "~Tutor/components/Sessions/ConfirmSessionButton"
import DeclineSessionButton from "~Tutor/components/Sessions/DeclineSessionButton"
import { AlertMessageBox, DescriptionItem } from "~tailwindui/Basics"
import Panel from "~tailwindui/Basics/Panel"

import classNames from "src/classNames"
import commaList from "src/commaList"
import dayjs from "src/dayjs"

export type OpportunityCardProps = {
  refetchQuery: VoidFunction
  session: {
    id: string
    startsAt: string
    endsAt: string
    statusState: "requested" | "substitute_requested"
    formattedSubstituteNotes: string
    formattedScheduledDuration: string
    subject: {
      id: string
      name: string
    }
    studyGroup: {
      id: string
      name: string
    }
    students: {
      id: string
      fullName: string
    }[]
    foreignLanguage: {
      id: string
      name: string
    }
    originalTutor: {
      id: string
      fullName: string
    }
  }
}

const OpportunityCard: React.FC<OpportunityCardProps> = ({
  session,
  refetchQuery,
}) => {
  return (
    <Panel
      className={classNames(
        "flex flex-col",
        session.statusState === "substitute_requested" ? "max-w-lg" : "max-w-sm"
      )}
    >
      {dayjs(session.startsAt).isBefore(dayjs()) && (
        <AlertMessageBox className="mt-0 w-full rounded-t-lg rounded-b-none">
          Session started {dayjs().diff(dayjs(session.startsAt), "minutes")}{" "}
          minutes ago. if you accept, please join quickly.
        </AlertMessageBox>
      )}

      <div className="flex flex-1 flex-col items-center justify-between space-y-3 py-4 px-6">
        <div className="text-center text-lg font-bold text-green-600">
          <span>
            {dayjs(session.startsAt).format("MMM D")}
            {dayjs(session.startsAt).isToday() ? "(today)" : null} at{" "}
            {dayjs(session.startsAt).format("h:mm A (z)")}
          </span>
          <div className="font-medium text-orange-600">
            {session.foreignLanguage?.name}
          </div>
        </div>

        <div className="text-sm">
          <DescriptionItem label="Subject" value={session.subject.name} />
          <DescriptionItem
            label="Duration"
            value={session.formattedScheduledDuration}
          />
          {session.studyGroup && (
            <DescriptionItem
              label="Study Group"
              value={session.studyGroup.name}
            />
          )}
          <DescriptionItem
            label="Students"
            value={commaList(session.students.map(student => student.fullName))}
          />

          {session.statusState === "substitute_requested" && (
            <>
              <DescriptionItem
                label="Original Tutor"
                value={session.originalTutor.fullName}
              />
              <DescriptionItem
                label="Notes"
                value={
                  <span
                    className="font-medium italic"
                    dangerouslySetInnerHTML={{
                      __html: session.formattedSubstituteNotes,
                    }}
                  />
                }
              />
            </>
          )}
        </div>
      </div>

      <div className="flex w-full items-center justify-center gap-4">
        <DeclineSessionButton id={session.id} refetchQuery={refetchQuery} />
        <ConfirmSessionButton id={session.id} refetchQuery={refetchQuery} />
      </div>
    </Panel>
  )
}

export default OpportunityCard
